import { useEffect } from 'react';

import { isPwaStandaloneWindow } from '@/lib/pwa';
import { SITE_NAME } from '@/lib/site-url';

const MIN_VISIBLE_MS = 1100;
const FADE_MS = 400;

export function PwaSplash() {
    useEffect(() => {
        const root = document.documentElement;
        if (!isPwaStandaloneWindow(window) || root.classList.contains('pwa-splash-done')) {
            return;
        }
        root.classList.add('pwa-standalone');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            root.classList.add('pwa-splash-done');
            document.getElementById('an-pwa-splash')?.setAttribute('hidden', '');
            return;
        }

        let hideTimer = 0;
        let removeTimer = 0;
        const started = performance.now();
        const dismiss = () => {
            const wait = Math.max(0, MIN_VISIBLE_MS - (performance.now() - started));
            hideTimer = window.setTimeout(() => {
                root.classList.add('pwa-splash-done');
                removeTimer = window.setTimeout(() => {
                    document.getElementById('an-pwa-splash')?.setAttribute('hidden', '');
                }, FADE_MS);
            }, wait);
        };

        if (document.readyState === 'complete') dismiss();
        else window.addEventListener('load', dismiss, { once: true });

        return () => {
            window.clearTimeout(hideTimer);
            window.clearTimeout(removeTimer);
        };
    }, []);

    return (
        <div id="an-pwa-splash" aria-hidden="true">
            <div className="an-pwa-splash-grid" />
            <img
                className="an-pwa-splash-wordmark"
                src="/images/logo.svg"
                width={280}
                height={59}
                alt={SITE_NAME}
            />
        </div>
    );
}
